import React from 'react';

import DesktopPopUp from '../../components/DesktopPopUp';
import styles from './scriptTriagePopUp.module.css';
import { ReactComponent as Kiwi } from '../../svgs/wavingKiwi.svg';
import { isDesktop } from '../../config';
import { go } from '../../routes';
import { getLoginPageURL } from '../../libs/utils';

function goToSignUp() {
  window.location = getLoginPageURL();
}

const content = (
  <div className={styles.background}>
    <div className={styles.container}>
      <Kiwi className={styles.kiwi} />
      <div className={styles.welcome}>
        {isDesktop() && 'Kia ora! '}
        Do you have an account with Vensa?
      </div>
      <button className={styles.newButton} onClick={goToSignUp}>
        I&#39;m new to Vensa
      </button>
      <a
        className={styles.loginButton}
        href={`${window.location.origin}/login?page=scripts`}
      >
        Log In
      </a>
    </div>
  </div>
);

const LoginTriage = ({ match }) => {
  if (isDesktop()) {
    return (
      <DesktopPopUp toggle={() => go.practiceProfile(match.params.orgId)}>
        {content}
      </DesktopPopUp>
    );
  }

  return content;
};

export default LoginTriage;
